import { H5 } from 'components/headings';
import { rem } from 'polished';
import styled from 'styled-components';

export const WarningCardStyled = styled.div`
  padding: ${rem(42)} ${rem(38)};
  background-color: ${({ theme }) => theme.colors.palette.orange};
  border-radius: 20px;

  ${({ theme }) => theme.mediaQueries.medium} {
    padding: ${rem(30)} ${rem(70)} ${rem(30)};
  }

  ${({ theme }) => theme.mediaQueries.smallMax} {
    padding: 1em;
  }
`;

export const TitleText = styled(H5)`
  color: ${({ theme }) => theme.colors.palette.black};
`;

export const ContentWrapper = styled.div`
  align-self: flex-start;

  svg {
    height: ${rem(24)};
    vertical-align: middle;
  }

  span {
    align-self: center;
    padding-left: 10px;
  }
`;
